import { inject, Inject, Injectable, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { NotificationModalComponent } from '../components/notification-modal/notification-modal.component';
import { NotificationModalOptions } from '../../utilities/models/notification-modal-options';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly modalService = inject(NgbModal);
  private readonly http = inject(HttpClient);

  private modalSpinner: any;

  toasts: any[] = [];

  openModal(options: NotificationModalOptions): Observable<any> {
    const modalRef = this.modalService.open(NotificationModalComponent, {
      size: options.size,
    });
    modalRef.componentInstance.options = options;

    return new Observable<any>((observer) => {
      modalRef.result.then(
        (result: boolean) => {
          observer.next(result);
        },
        (reason: any) => {
          observer.next(reason);
        }
      );
    });
  }

  showToast(textOrTpl: string | TemplateRef<any>, options: { type?: 'success' | 'danger' | 'warning'; delay?: number; autohide?: boolean } = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  removeToast(toast: any) {
    this.toasts = this.toasts.filter((t) => t != toast);
  }

  showModalSpinner() {
    this.modalSpinner = this.modalService.open(NotificationModalComponent, {
      size: 'sm',
      centered: true,
      keyboard: false,
    });
    this.modalSpinner.componentInstance.options = {
      type: 'spinner',
    };
  }

  hideModalSpinner() {
    this.modalSpinner?.close();
  }

  sendSupportRequest(data: any): Observable<any> {
    return this.http.post(`${environment.API.orchestrator_configurator}/support`, data);
  }
}
